import { render, staticRenderFns } from "./ContentInfo.vue?vue&type=template&id=c225c802&scoped=true&"
import script from "./ContentInfo.vue?vue&type=script&lang=js&"
export * from "./ContentInfo.vue?vue&type=script&lang=js&"
import style0 from "./ContentInfo.vue?vue&type=style&index=0&id=c225c802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c225c802",
  null
  
)

export default component.exports